module.exports = __webpack_public_path__ + "static/img/atomicmind-apply-logo.e45ceb40.svg";